import React, { useContext } from 'react';
import { AuthContext } from '@context/AuthContext'; 
import { useNavigate} from 'react-router-dom';
import { HeaderContext } from '@context/HeaderContext';

const MyPageLeftMenuStudent = () => {
    const { auth } = useContext(AuthContext);
    const { subMenu, setSubMenu } = useContext(HeaderContext);
    const navigate = useNavigate();

    const handleMenuClick = (menuName) => {
        setSubMenu(menuName);

        switch (menuName) {
            case '나의 교육정보':
                navigate('/myLectures/myStudentLectures');
                break; 
            case '수료정보':
                navigate('/myLectures/myCompletionStudent');
                break;
            case '개인정보관리':
                //navigate('/myLectures/myStudentProfile');
                navigate('/myLectures/reconfirm-password/student');
                break;
            default:
                break;
        }
    };

    const menuItems = [
        {
            name: '나의 교육정보',
            path: '/myLectures/myStudentLectures',
          },
        {
            name: '수료정보',
            path: '/myLectures/myCompletionStudent',
        },
        {
            name: '개인정보관리',
            //path: '/myLectures/myStudentInfo',
            path: '/myLectures/reconfirm-password/student',
        },
    ];
    return (
        <div className="left-menu">
            <h2>MY메뉴</h2>
            <div className="profile">
                <p>{auth.name} ({auth.role === 'ROLE_USER' ? '수강생' : ''})</p>
                {/* <p>최근 접속일<br />
                    <span>{auth.loginTime}</span>
                </p> */}
            </div>
            <div>
                <ul>
                {menuItems.map((item) => (
                    <li
                        key={item.name}
                        onClick={() => handleMenuClick(item.name)}
                        className={
                        subMenu === item.name ? "sub-menu-on" : ""
                        }
                    >
                        {item.name}
                    </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default MyPageLeftMenuStudent;
